import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { changeMappingActivity, ChangeMappingActivityResponse } from 'config/requests/gatewayRules';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { queryClient } from 'providers/queryClient';
import { useNotify } from 'react-admin';

type UseChangeMappingActivityReturnValue = {
  changeMappingActivityMutation: UseMutationResult<
    AxiosResponse<ChangeMappingActivityResponse, any>,
    unknown,
    { id: string; active: boolean },
    unknown
  >;
};

export function useChangeMappingActivity(): UseChangeMappingActivityReturnValue {
  const translate = useTypedTranslate();
  const notify = useNotify();

  const mutation = useMutation({
    mutationFn: ({ id, active }: { id: string; active: boolean }) =>
      changeMappingActivity(id, active),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mappings'] });
      queryClient.invalidateQueries({ queryKey: ['gateway_rules'] });
      notify(translate('app.common.activityChanged'), { type: 'success' });
    },
    onError: (e) => {
      const error = e as AxiosError;
      notify(`${translate('app.common.error')}: ${error}`, { type: 'error' });
    },
  });

  return { changeMappingActivityMutation: mutation };
}
